export const compassDirections = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];
export const turnDirections = ["LT", "RT"];
//# sourceMappingURL=compassDirection.js.map